var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import detectEthereumProvider from "@metamask/detect-provider";
import { ADAPTER_EVENTS, ADAPTER_STATUS, SUPPORTED_ADAPTERS, BaseAdapter, log, } from "../base";
class MetamaskAdapter extends BaseAdapter {
    constructor() {
        super(...arguments);
        this.name = SUPPORTED_ADAPTERS.METAMASK;
        this.status = ADAPTER_STATUS.NOT_READY;
        this.metamaskProvider = null;
        this.autoReconnected = false;
    }
    get provider() {
        if (this.status === ADAPTER_STATUS.CONNECTED && this.metamaskProvider) {
            return this.metamaskProvider;
        }
        return null;
    }
    get chainId() {
        if (this.metamaskProvider) {
            return this.metamaskProvider.chainId;
        }
        return null;
    }
    set chainId(_) {
        throw new Error("Not implemented");
    }
    _init(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            this.metamaskProvider =
                yield detectEthereumProvider({
                    mustBeMetaMask: true,
                });
            if (!this.metamaskProvider)
                return;
            this.status = ADAPTER_STATUS.READY;
            this.emit(ADAPTER_EVENTS.READY, SUPPORTED_ADAPTERS.METAMASK);
            try {
                log.debug("initializing metamask adapter");
                if (options.autoConnect) {
                    yield this.connect();
                }
            }
            catch (error) {
                this.emit(ADAPTER_EVENTS.ERRORED, error);
            }
        });
    }
    _connect() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.metamaskProvider)
                throw Error("Not able to connect with metamask");
            this.status = ADAPTER_STATUS.CONNECTING;
            this.emit(ADAPTER_EVENTS.CONNECTING, {
                adapter: SUPPORTED_ADAPTERS.METAMASK,
            });
            try {
                const accounts = yield this.metamaskProvider.request({
                    method: "eth_requestAccounts",
                });
                const { chainId } = this.metamaskProvider;
                if (chainId !== this.currentChainConfigId) {
                    yield this.switchChain(this.currentChainConfigId);
                }
                yield this.postConnected(accounts[0]);
                if (!this.provider)
                    throw Error("Failed to connect with provider");
                return this.provider;
            }
            catch (error) {
                // ready again to be connected
                this.status = ADAPTER_STATUS.READY;
                this.emit(ADAPTER_EVENTS.ERRORED, error);
                log.error(error);
                throw Error("Failed to login with metamask wallet");
            }
        });
    }
    _disconnect() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this.metamaskProvider) === null || _a === void 0 ? void 0 : _a.removeAllListeners();
            // ready to be connected again
            this.status = ADAPTER_STATUS.READY;
            this.emit(ADAPTER_EVENTS.DISCONNECTED);
        });
    }
    _switchChain(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this.metamaskProvider) === null || _a === void 0 ? void 0 : _a.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId }],
            }));
            this.setAdapterSettings({
                chainId,
            });
        });
    }
    postConnected(address) {
        return __awaiter(this, void 0, void 0, function* () {
            log.debug(`metamask postconnected`);
            // only called when the adapter is connected
            const disconnectHandler = (error) => {
                var _a;
                if (error.code === 1013) {
                    // sometimes metamask throws this error when the user changes the network
                    log.debug("MetaMask logged connection error 1013");
                    return;
                }
                // ready to be connected again
                this.disconnect();
                (_a = this.metamaskProvider) === null || _a === void 0 ? void 0 : _a.removeListener("disconnect", disconnectHandler);
                if (this.autoReconnected)
                    return;
                this.autoReconnected = true;
                this.connect();
            };
            this.metamaskProvider.on("accountsChanged", (accounts) => {
                log.debug(`accountsChanged: ${accounts}`);
                this.emit(ADAPTER_EVENTS.ACCOUNT_CHANGED, { accounts });
            });
            this.metamaskProvider.on("chainChanged", (chainId) => {
                log.debug(`chainChanged: ${chainId}`);
                this.emit(ADAPTER_EVENTS.CHAIN_CHANGED, { chainId });
            });
            this.metamaskProvider.on("disconnect", disconnectHandler);
            this.status = ADAPTER_STATUS.CONNECTED;
            this.emit(ADAPTER_EVENTS.CONNECTED, {
                adapter: SUPPORTED_ADAPTERS.METAMASK,
                status: {
                    chainId: this.metamaskProvider.chainId,
                    address,
                },
            });
            this.autoReconnected = false;
            log.debug(`metamask finished postconnected`);
        });
    }
}
export { MetamaskAdapter };
//# sourceMappingURL=metamaskAdapter.js.map